// extracted by mini-css-extract-plugin
module.exports = {"LoginPageHolder":"LoginStyles_LoginPageHolder__2_A1W","Logo":"LoginStyles_Logo__2JFjG","LoginButton":"LoginStyles_LoginButton__2MDdI"};